export default function R_Matrices() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Matrices Component</h1>
      <p>This is the R_Matrices tutorial section.</p>
    </div>
  );
}
